import { useState, useRef, useEffect } from 'react';

import './style.scss';

import artComplex01 from 'assets/Desktop/images/parcelOut/cg_birds_view.jpg';
import artComplex02 from 'assets/Desktop/images/parcelOut/cg_perspective.jpg';

import communityLayout01 from 'assets/Desktop/images/parcelOut/community_iso_01.png';
import communityLayout02 from 'assets/Desktop/images/parcelOut/community_iso_02.png';

import dongho01 from 'assets/Desktop/images/parcelOut/danji.jpg';
import dongho01_big from 'assets/Desktop/images/parcelOut/danji_big.jpg';
import dongho02 from 'assets/Desktop/images/parcelOut/keymap.png';
import dongho03 from 'assets/Desktop/images/parcelOut/dongho.png';
import dongho03_big from 'assets/Desktop/images/parcelOut/dongho_big.png';

import complexLayout01 from 'assets/Desktop/images/parcelOut/danji_cg_01.jpg';
import complexLayout01_big from 'assets/Desktop/images/parcelOut/danji_cg_01_big.jpg';
import complexLayout02 from 'assets/Desktop/images/parcelOut/danji_cg_02.jpg';
import complexLayout02_big from 'assets/Desktop/images/parcelOut/danji_cg_02_big.jpg';
import complexLayout03 from 'assets/Desktop/images/parcelOut/danji_cg_03.jpg';
import complexLayout03_big from 'assets/Desktop/images/parcelOut/danji_cg_03_big.jpg';
import complexLayout04 from 'assets/Desktop/images/parcelOut/danji_cg_04.jpg';
import complexLayout04_big from 'assets/Desktop/images/parcelOut/danji_cg_04_big.jpg';

import SidebarScroll, { Element } from '../../SidebarScroll';

import { observer } from 'mobx-react';

import ImgPopup from '../../ImgPopup';
import Slide from './Slide';
import { listContent, listPromition } from 'data/street';

const Street = observer(() => {
  const infoRef = useRef<any>(null);
  const layoutRef = useRef<any>(null);
  const environmentRef = useRef<any>(null);
  const communityRef = useRef<any>(null);
  const donghoRef = useRef<any>(null);

  const [isImgPopupOpen, setIsImgPopupOpen] = useState(false);
  const [popupImg, setPopupImg] = useState('');
  const [popupTitle, setPopupTitle] = useState('');
  
  const handleClickImg = (img: string, title: string) => {
    setIsImgPopupOpen(true);
    setPopupImg(img);
    setPopupTitle(title);
  };


  // modal ref
  const imgModalRef = useRef<any>();
  const modalRef = useRef<any>();

  const sidebarList = [
    { name: '특징', isActive: true },
    { name: '단지 배치도', isActive: true },
    { name: '단지 환경', isActive: true },
    { name: '커뮤니티', isActive: true },
    { name: '동호 배치', isActive: true },
    { name: '시스템', isActive: true }
  ];

  return (
    <div className="contents-street">
      <div className="content">
        <SidebarScroll sidebarList={sidebarList} />

        {/* 특징 */}
        {sidebarList[0].isActive ? (
        <Element name={sidebarList[0].name}>
          <div ref={infoRef} id="infoMap" className="infoMap">
            <div className="infoMap-icon">
              <div className="icon"></div>
            </div>
            <div className="infoMap-title">광주를 대표할 랜드마크 단지답게<br />단지 곳곳에 적용한 특화 설계와 커뮤니티</div>
            {/* <div className="infoMap-detail">자녀 교육의 메카, 광주 미래의 중심</div> */}
            {/* <div className="infoMap-content">
              {
                listPromition.map((v, key) => {
                  return (
                    <div key={key} className="infoMap-content-items">
                      <div className="title"> <pre>{v.title}</pre> </div>
                      <div className="line"></div>
                      <div className="text"> {v.desc} </div>
                    </div>
                  )
                })
              }
            </div> */}
            <div className="infoMap-content-img">
              <img src={artComplex01} alt="artComplex01"
                onClick={() => {
                  handleClickImg(artComplex01, '조감도');
                }}
              />
              <img className="mt-30" src={artComplex02} alt="artComplex02" 
                onClick={() => {
                  handleClickImg(artComplex02, '투시도');
                }}
              />
            </div>
            <div className="infoMap-content-caution">
              * 본 홈페이지 조감도, 투시도는 소비자의 이해를 돕기 위한 것으로 실제와 차이가 날 수 있으며, 건축물의 입면 등 외관 및 색채계획, 창호계획 등은 일부 변경될 수 있습니다.
            </div>
          </div>
        </Element>
        ) : null}

        {/* 단지 배치도 */}
        {sidebarList[1].isActive ? (
        <Element name={sidebarList[1].name}>
          <div ref={layoutRef} id="layout" className="layout">
            <h3>단지 배치도</h3>
            <div className="layout-img">
              <img src={dongho01} alt="mainComplexLayout" 
                onClick={() => {
                  handleClickImg(dongho01_big, '단지 배치도');
                }}
              />
            </div>
            <div className="layout-caution">
              * 본 홈페이지 단지 배치도와 단지 주변환경은 소비자의 이해를 돕기 위한 것으로 실제와 차이가 있을 수 있으니 현장에서
              자세히 확인하시기 바랍니다.
            </div>
            <div className="layout-summary">
              <ul className='list'>
                <li><span>주출입구</span> - e편한세상의 시그니처가 적용되어 자부심이 시작되는 공간</li>
                <li><span>중앙광장</span> - 넓은 잔디 마당을 조성하여 가슴까지 탁 트이는 자연친화적 공간</li>
                <li><span>어린이놀이터</span> - 흥미로운 이야기가 있는 다양한 테마형 어린이놀이터</li>
                <li><span>주민운동시설</span> - 주민들의 건강한 야외 활동을 위한 운동시설과 휴게시설을 갖춘 건강 힐링공간</li>
              </ul>
            </div>
          </div>
        </Element>
        ) : null}

        {/* 단지 환경 */}
        {sidebarList[2].isActive ? (
        <Element name={sidebarList[2].name}>
          <div ref={layoutRef} id="layout" className="layout">
            <h3>단지 환경</h3>
          </div>
          <div ref={environmentRef} id="environment" className=" environment">
            <div className="layout-list-image">
              <div className="layout-list-image-item">
                <img src={complexLayout01} alt={'complexLayout01'} 
                  onClick={() => {
                    handleClickImg(complexLayout01_big, '주출입구');
                  }}
                />
                <div className="desc-img">주출입구</div>
              </div>
              <div className="layout-list-image-item">
                <img src={complexLayout02} alt={'complexLayout02'} 
                  onClick={() => {
                    handleClickImg(complexLayout02_big, '어린이 놀이터');
                  }}
                />
                <div className="desc-img">어린이 놀이터</div>
              </div>
              <div className="layout-list-image-item mt-30">
                <img src={complexLayout03} alt={'complexLayout03'} 
                  onClick={() => {
                    handleClickImg(complexLayout03_big, '근린생활시설');
                  }}
                />
                <div className="desc-img">근린생활시설</div>
              </div>
              <div className="layout-list-image-item mt-30">
                <img src={complexLayout04} alt={'complexLayout04'} 
                  onClick={() => {
                    handleClickImg(complexLayout04_big, '중앙광장');
                  }}
                />
                <div className="desc-img">중앙광장</div>
              </div>
            </div>
            <div className="layout-caution">* 상기 이미지들은 소비자의 이해를 돕기 위한 것으로 실제와 다를 수 있습니다.</div>
          </div>
        </Element>
        ) : null}

        {/* 커뮤니티 */}
        {sidebarList[3].isActive ? (
        <Element name={sidebarList[3].name}>
          <div ref={communityRef} id="community" className="community">
            <h3>커뮤니티</h3>
            <div className="community-design">
              <img src={communityLayout01} alt="communityLayout01" 
                  onClick={() => {
                    handleClickImg(communityLayout01, '커뮤니티');
                  }}
                />
            </div>
            <div className="community-caution">
              <p>* 본 이미지는 소비자의 이해를 돕기 위한 것으로 실제와 다를 수 있습니다.</p>
            </div>
          </div> 
        </Element>
        ) : null}

        {/* 동호 배치 */}
        {sidebarList[4].isActive ? (
        <Element name={sidebarList[4].name}>
          <div ref={donghoRef} id="donghoArrangement">
            <div className="donghoArrangement">
              <h3>동호 배치</h3>
              <div className="donghoArrangement-img">
                <img
                  onClick={() => {
                    if (imgModalRef && modalRef) {
                      handleClickImg(dongho02, '동호배치도');
                    }
                  }}
                  src={dongho02}
                  alt="dongho02"
                  className='img-line'
                />
              </div>
              <div className="donghoArrangement-caution">
                * 본 홈페이지 동호 배치도와 주택형 표의 색채는 주택형과 배치도의 이해를 돕기 위한 것으로 실제 시공 시에 달라질 수 있습니다.
              </div>
              <div className="donghoArrangement-img mt-40">
                <img
                  onClick={() => {
                    if (imgModalRef && modalRef) {
                      handleClickImg(dongho03_big, '동호배치표');
                    }
                  }}
                  src={dongho03}
                  alt="dongho03"
                />
              </div>
              <div className="donghoArrangement-table">
                <div className="table-container type01">
                  <table className="table-col">
                    <colgroup>
                      {listContent.map((contents, idx) => {
                        return <col key={idx} style={{ width: `calc(100% / ${listContent.length + 1})` }} />;
                      })}
                    </colgroup>

                    <thead>
                      <tr>
                        <th>주택형(㎡)</th>
                        {listContent.map((contents, idx) => {
                          return (
                            <th key={idx} className={contents.color}>
                              {' '}
                              {contents.tit}{' '}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th>일반 분양 세대수</th>
                        {listContent.map((contents, idx) => {
                          return <td key={idx}>{contents.subtit}</td>;
                        })}
                      </tr>
                      <tr>
                        <th>총 세대수</th>
                        {listContent.map((contents, idx) => {
                          return <td key={idx}>{contents.total}</td>;
                        })}
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="note">* 총 542세대(일반분양 176세대)</div>
              </div>
              
            </div>
          </div>
        </Element>
        ) : null}

        {/* 시스템 */}
        {sidebarList[5].isActive ? (
        <Element name={sidebarList[5].name}>
          <Slide />
        </Element>
        ) : null}
      </div>

      <ImgPopup title={popupTitle} img={popupImg} open={isImgPopupOpen} setOpen={setIsImgPopupOpen} />
    </div>
  );
});

export default Street;
